import { Theme } from "../types"
import { sizes, colors, spaces } from "./foundation"
import {
  backgroundColors,
  borderWidths,
  borderColors,
  borderRadii,
  iconSizes,
  iconColors,
  fonts,
  fontSizes,
  lineHeights,
  fontWeights,
  textColors,
} from "./contextual"
import {
  button,
  textButton,
  iconButton,
  headingFontSizes,
  headingLineHeights,
  textFontSizes,
  textLineHeights,
  textFontWeights,
} from "./component"

export const LivingsocialTheme: Theme = {
  key: "livingsocial",
  sizes,
  colors,
  spaces,
  backgroundColors,
  borderWidths,
  borderColors,
  borderRadii,
  iconSizes,
  iconColors,
  fonts,
  fontSizes,
  lineHeights,
  fontWeights,
  textColors,
  button,
  textButton,
  iconButton,
  headingFontSizes,
  headingLineHeights,
  textFontSizes,
  textLineHeights,
  textFontWeights,
}
